import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-alarm-event-switch",
  "use": "app-icon-alarm-event-switch-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"app-icon-alarm-event-switch\"><path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm.7 10.5l-1.4 1.4L3 7.7l1.4-1.4 2.8 2.8 4.2-4.2L13 6.3l-4.3 4.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol